import {combineReducers} from 'redux';
import userReducer from './userReducer';
import variablesReducer from './variablesReducer';
export default combineReducers({
    user: userReducer,
    variables: variablesReducer
});